import "./OEMEquipmentManufacturers2.module.css";
import Header from "@/reusable_sections/Header";
import PageHeader from "./sections/PageHeader";
import DirectAnswerBlock from "./sections/DirectAnswerBlock";
import WhyOemManufacturersUseEvermark from "./sections/WhyOemManufacturersUseEvermark";
import WhatEvermarkSuppliesOems from "./sections/WhatEvermarkSuppliesOems";
import HowAnOemProgramWorks from "./sections/HowAnOemProgramWorks";
import ConsistencyTraceabilityStandards from "./sections/ConsistencyTraceabilityStandards";
import HowToSetUpAProgram from "./sections/HowToSetUpAProgram";
import OemMarkingProgramsCommonQuestions from "./sections/OemMarkingProgramsCommonQuestions";
import ClosingCta from "./sections/ClosingCta";
import Footer from "@/reusable_sections/Footer";
export default function OEMEquipmentManufacturers2Page() {
  return <div>
      <Header />
      <PageHeader />
      <DirectAnswerBlock />
      <WhyOemManufacturersUseEvermark />
      <WhatEvermarkSuppliesOems />
      <HowAnOemProgramWorks />
      <ConsistencyTraceabilityStandards />
      <HowToSetUpAProgram />
      <OemMarkingProgramsCommonQuestions />
      <ClosingCta />
      <Footer />
    </div>;
}